module.exports = __webpack_public_path__ + "static/img/21.6317545.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/eng/21.png
// module id = BVrI
// module chunks = 0